import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';

import { deleteEntityV2 } from '../../../actions/website/EntityActions';
import { hideModal } from '../../../actions/ModalActions';

function DeleteEntityModal(props) {
  const { onSubmit, onCancel, entity } = props;

  return (
    <div className="text-center">
      <div className="modal-header">
        <h3 className="modal-title">Are you sure you want to remove this from your website?</h3>
      </div>
      <div className="modal-body" />
      <div className="modal-footer">
        <div className="text-center">
          <ButtonV2 onClick={() => onSubmit(entity)}>Remove</ButtonV2>
          <ButtonV2 variant="secondary" className="separator--one" onClick={onCancel}>
            Cancel
          </ButtonV2>
        </div>
      </div>
    </div>
  );
}

DeleteEntityModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  entity: PropTypes.shape({}).isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: entity => {
    dispatch(deleteEntityV2(entity)).then(() => {
      dispatch(hideModal());
      if (ownProps.callback) ownProps.callback();
    });
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DeleteEntityModal);



// WEBPACK FOOTER //
// ./src/components/manage/website/DeleteEntityModal.jsx